import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import type { ReactNode } from "react";

import { Toaster } from "@profitlens/ui/toast";
import { TooltipProvider } from "@profitlens/ui/tooltip";

import { createQueryClient } from "./query-client";
import { SessionBootstrap } from "./session-bootstrap";
import { ThemeEffect } from "./theme-effect";

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={200}>
        <ThemeEffect />
        <SessionBootstrap>{children}</SessionBootstrap>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
